



















































































































































import { Component, Prop, Mixins } from "vue-property-decorator";
import { appModule } from "@/store/modules/app";
import { userModule } from "@/store/modules/user";
import { alasanTtdMengunciHapus } from "@/utils/hapusSetelahTtd";
import { confirmRemove } from "@/utility/CommonHelper";
import FormAuthorization from "@/mixins/FormAuthorization";
import SkriningBunuhDiriService from "@/services/SkriningBunuhDiri";
import CardSkriningBunuhDiri from "@/components/pemeriksaan/assesmen/skriningbunuhdiri/CardSkriningBunuhDiri.vue";
import CardModalTtd from "@/components/modal/CardModalTtd.vue";
import {
  SBD_ALASAN_PENGKAJIAN,
  SBD_INSTRUMEN,
  SBD_ITEMS,
  SBD_PERILAKU_NONVERBAL,
  SBD_TANDA_RISIKO_AKUT,
  SbdOption,
  optionText
} from "@/constants/skriningBunuhDiri";

const SOP_ITEM_LABELS = SBD_ITEMS.reduce((labels, item) => {
  labels[item.code] = `${item.no}. ${item.label}`;
  return labels;
}, {} as Record<string, string>);

const ITEM_LABELS = {
  ...SOP_ITEM_LABELS,
  CSSRS_S_Q1: "1. Berharap mati / tertidur tidak bangun",
  CSSRS_S_Q2: "2. Pikiran aktif mengakhiri hidup",
  CSSRS_S_Q3: "3. Memikirkan metode tanpa rencana",
  CSSRS_S_Q4: "4. Niat tanpa rencana",
  CSSRS_S_Q5: "5. Niat dengan rencana spesifik",
  CSSRS_S_Q6: "6. Perilaku bunuh diri (3 bln)",
  PSS3_Q1: "1. Depresi (2 minggu)",
  PSS3_Q2: "2. Berpikir bunuh diri (2 minggu)",
  PSS3_Q3: "3. Percobaan (seumur hidup)"
};

@Component({
  components: { CardSkriningBunuhDiri, CardModalTtd },
  inject: { isReadOnly: { default: () => () => false } }
})
export default class SkriningBunuhDiriPage extends Mixins(FormAuthorization) {
  @Prop() register!: string;
  @Prop() rm!: string;
  @Prop({ default: "ralan" }) encounterType!: string;
  isReadOnly!: () => boolean;

  get readOnly(): boolean {
    return this.isReadOnly();
  }

  headers = [
    { text: "Tanggal", value: "tanggal_skrining" },
    { text: "Instrumen", value: "instrumen", sortable: false },
    { text: "Hasil", value: "level_risiko", sortable: false },
    { text: "TTD", value: "status_ttd", sortable: false },
    { text: "Aksi", value: "actions", sortable: false }
  ];

  tandaAkutOptions = SBD_TANDA_RISIKO_AKUT;
  perilakuOptions = SBD_PERILAKU_NONVERBAL;

  loadingList = false;
  editItem = null;
  listData = [];
  expanded = [];

  // signing
  showTtd = false;
  signTarget: any = null;
  signRole = "";

  mounted() {
    this.getByRegister();
  }

  getByRegister() {
    this.loadingList = true;
    SkriningBunuhDiriService.getByRegister(this.register)
      .then(resp => {
        if (resp && resp.data) this.listData = resp.data;
      })
      .finally(() => {
        this.loadingList = false;
      });
  }

  onSaved() {
    this.getByRegister();
  }

  itemLabel(code) {
    return ITEM_LABELS[code] || code;
  }

  isSop(item): boolean {
    return item.instrumen === SBD_INSTRUMEN;
  }

  instrumenLabel(instrumen: string): string {
    const map = { [SBD_INSTRUMEN]: "SOP RSPS", pss3: "PSS-3", cssrs_screener: "C-SSRS" };
    return map[instrumen] || instrumen;
  }

  alasanLabel(item): string {
    if (!item.alasan_pengkajian) return "-";
    const label = optionText(SBD_ALASAN_PENGKAJIAN, item.alasan_pengkajian);
    return item.alasan_pengkajian === "lainnya" && item.alasan_pengkajian_lainnya
      ? `${label}: ${item.alasan_pengkajian_lainnya}`
      : label;
  }

  pendampingLabel(adaPendamping: boolean | null): string {
    if (adaPendamping === true) return "Ada";
    if (adaPendamping === false) return "Tidak";
    return "-";
  }

  optionList(options: SbdOption[], values: string[] | null): string {
    if (!values || !values.length) return "Tidak ada";
    return values.map(v => optionText(options, v)).join(", ");
  }

  targetLabel(jam: number | null): string {
    if (jam === null || jam === undefined) return "Sesuai kondisi";
    return jam === 0 ? "Segera" : `Maks. ${jam} jam`;
  }

  jawabanLabel(j) {
    const map = { yes: "Ya", no: "Tidak", declined: "Menolak", na: "N/A" };
    return map[j] || j;
  }

  getLevelColor(level) {
    const map = { none: "green", rendah: "amber darken-2", sedang: "orange", tinggi: "red", imminent: "red darken-4" };
    return map[level] || "grey";
  }

  edit(item) {
    if (this.validateUserEdit(item.creator_user_id)) {
      this.editItem = JSON.parse(JSON.stringify(item));
    }
  }

  bisaHapus(item) {
    const slot = [
      { ditandatangani: item.signed_pelaksana_at, penandaTanganId: item.pelaksana_user_id },
      { ditandatangani: item.signed_dpjp_at, penandaTanganId: item.reviewer_dpjp_user_id },
      { ditandatangani: item.signed_sp_kj_at, penandaTanganId: item.reviewer_sp_kj_user_id }
    ];
    if (item.is_locked && !slot.some(s => s.ditandatangani)) {
      slot.push({ ditandatangani: true, penandaTanganId: null });
    }
    return !alasanTtdMengunciHapus(item.creator_user_id, slot, userModule.user?.id);
  }

  remove(item) {
    if (!this.bisaHapus(item)) return;
    if (this.validateUserEdit(item.creator_user_id) && confirmRemove("Skrining Risiko Bunuh Diri")) {
      SkriningBunuhDiriService.destroy(item.id).then(() => {
        appModule.NoticeDelay("Berhasil menghapus skrining");
        this.editItem = null;
        this.getByRegister();
      });
    }
  }

  printPdf(id) {
    SkriningBunuhDiriService.printPdf(id);
  }

  openSign(item, role) {
    this.signTarget = item;
    this.signRole = role;
    this.showTtd = true;
  }

  doSign(password) {
    if (!this.signTarget) return;
    SkriningBunuhDiriService.sign(this.signTarget.id, { role: this.signRole, password })
      .then(resp => {
        if (resp && resp.status == "1") {
          appModule.NoticeDelay(resp.message || "Berhasil menandatangani");
          this.getByRegister();
        }
      })
      .finally(() => {
        this.showTtd = false;
        this.signTarget = null;
      });
  }

  markDone(item, tl) {
    SkriningBunuhDiriService.markTindakLanjut(item.id, tl.id, { status: "done" }).then(resp => {
      if (resp && resp.status == "1") {
        appModule.NoticeDelay("Tindak lanjut ditandai selesai");
        this.getByRegister();
      }
    });
  }

  aktivasiCodeBlue(item) {
    this.$set(item, "_cb", true);
    SkriningBunuhDiriService.aktivasiCodeBlue(item.id)
      .then(resp => {
        if (resp && resp.status == "1") {
          appModule.NoticeDelay(resp.message);
          this.getByRegister();
        }
      })
      .finally(() => this.$set(item, "_cb", false));
  }
}
